import {useState,type ReactNode} from 'react';

/** Audit F-055 (change #15): a collapsed <details> still mounts its children, so every panel inside it fetched on
 * page load even when nobody opened it. This renders the children only once the section is first opened (or when
 * the page was opened at one of `openForHashes`), then keeps them mounted. */
export function LazyDetails({summary,className,children,openForHashes=[]}:{summary:ReactNode;className?:string;children:ReactNode;openForHashes?:readonly string[]}){
 const initiallyOpen=typeof window!=='undefined'&&openForHashes.includes(window.location.hash);
 const [opened,setOpened]=useState(initiallyOpen);
 return <details className={className} open={initiallyOpen||undefined} onToggle={event=>{if(event.currentTarget.open)setOpened(true);}}>
  <summary>{summary}</summary>
  {opened?children:null}
 </details>;
}
